import {
  ReportSection,
  ReportSectionItemContent,
  ReportSectionItemTable,
} from '@/components';
import type {
  InspectionEvaluationRsModel,
  ProjectModel,
} from '@/features/project/projects/_models/project';
import { FALLBACK_TEXT } from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type Props = {
  project: z.infer<typeof ProjectModel>;
};

export const AlurDanaSerupa: FC<Props> = ({ project }) => {
  const { t } = useTranslation();

  const inspectionEvaluation = project.inspectionEvaluation as z.infer<
    typeof InspectionEvaluationRsModel
  >;

  return (
    <>
      <ReportSection
        title="H. Bagan Alur Dana Program"
        items={[
          {
            // indexText: '22.',
            subtitle: t('penjelasan-tentang-kegiatan-penerima-dana'),
            item: (
              <ReportSectionItemContent
                value={
                  inspectionEvaluation
                    ?.inspectionAndImprovementByAdministrativeJurisdiction
                    ?.analysisOfValidity
                }
              />
            ),
          },
        ]}
      />
      <ReportSection
        title="I. Penerima Dana Peringkat 10"
        items={[
          {
            item: (
              <ReportSectionItemTable
                header={[
                  {
                    type: 'text',
                    value: t('number'),
                    ratio: 10,
                  },
                  {
                    type: 'text',
                    value: t('penerima-dana'),
                    ratio: 20,
                  },
                  {
                    type: 'text',
                    value: t('ringkasan-kegiatan'),
                    ratio: 20,
                  },
                  {
                    type: 'text',
                    value: t('jumlah-dana'),
                    ratio: 10,
                  },
                  {
                    type: 'text',
                    value: t('metode-kontrak-dll'),
                    ratio: 15,
                  },
                  {
                    type: 'text',
                    value: t('jumlah-peserta-tender'),
                    ratio: 15,
                  },
                  {
                    type: 'text',
                    value: t('tingkat-kemenangan-tender'),
                    ratio: 10,
                  },
                ]}
                data={
                  project.indonesiaData?.alurDana?.map((alurDana) => ({
                    row: [
                      { type: 'text', value: alurDana.number },
                      { type: 'text', value: alurDana.penerimaDana },
                      { type: 'text', value: alurDana.ringkasanKegiatan },
                      { type: 'text', value: alurDana.jumlahDana },
                      { type: 'text', value: alurDana.metodeKontrakDll },
                      { type: 'text', value: alurDana.jumlahPesertaTender },
                      { type: 'text', value: alurDana.tingkatKemenanganTender },
                    ],
                  })) ?? [{ row: [{ type: 'text', value: FALLBACK_TEXT }] }]
                }
              />
            ),
          },
        ]}
      />
    </>
  );
};
